// Instagram/Facebook/TikTok/etc.'s built-in browser is a common source of
// silently-empty photo uploads during checkout (files arrive as 0 bytes even
// though they're valid on the customer's phone) - it's far more
// memory-constrained than real Safari/Chrome and known industry-wide to
// mishandle large file uploads. Detecting it lets us warn the customer BEFORE
// they spend several minutes selecting photos, instead of after batches
// start failing partway through checkout.
export const detectInAppBrowser = () => {
  const ua = navigator.userAgent || "";
  if (/Instagram/i.test(ua)) return "Instagram";
  if (/FBAN|FBAV/i.test(ua)) return "Facebook";
  if (/musical_ly|TikTok/i.test(ua)) return "TikTok";
  if (/MicroMessenger/i.test(ua)) return "WeChat";
  if (/Line\//i.test(ua)) return "Line";
  return null;
};
